<script module lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface ResultOptionProps extends SbBlokData {
		component: 'quiz_coupon_code_result_option';
		quote: string;
		customer_name: string;
		tracking_label: string;
	}
</script>

<script lang="ts">
	import { editable } from '$lib/storyblok/editable';

	interface Props {
		content: ISbStoryData<ResultOptionProps>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="text-brown-1">
	<p class="mb-3 text-balance text-[14px]/[160%]">“{content.quote}”</p>

	<div class="text-[14px]/[160%]">
		<p>
			{content.customer_name}
		</p>
		<p class="text-green-3">Verified Buyer</p>
	</div>
</div>
